import { default as Container } from '@mui/material/Container';
import { IMAGES } from 'config/images';
import { Layout } from 'modules/minimal-ui-theme';
import { LoginButton } from './LoginButton';

export const ZENJOB_LOGO_ALT_TEXT = 'Zenjob Pro Logo';

const childrenStyles = {
  height: '100%',
  img: {
    position: 'absolute',
    top: '42%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '78%',
    maxHeight: '45vh'
  }
};

const buttonContainer = {
  style: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    position: 'absolute',
    bottom: '12vh',
    left: '50%',
    transform: 'translateX(-50%)'
  }
};

export const LoginScreen = () => (
  <Layout backgroundColor="background.default" childrenStyles={childrenStyles}>
    <img alt={ZENJOB_LOGO_ALT_TEXT} src={IMAGES.proLogoPurple} />
    <Container maxWidth="sm" sx={buttonContainer.style}>
      <LoginButton />
    </Container>
  </Layout>
);
